(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const mobileMenuQuery = window.matchMedia('(max-width: 72rem)');
    const focusableSelector =
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    const getElementPreview = (element) => ({
      image: element?.dataset.previewImage || '',
      alt: element?.dataset.previewAlt || '',
      description: element?.dataset.previewDescription || '',
      html: element?.dataset.previewHtml || '',
      href:
        element?.dataset.previewHref ||
        (element instanceof HTMLAnchorElement ? element.getAttribute('href') || '' : ''),
      linkLabel: element?.dataset.previewLinkLabel || '',
      pageLinkLabel: element?.dataset.previewPageLinkLabel || '',
    });

    const initHeader = (root) => {
      if (!root || root.dataset.astroHeaderInitialized === 'true') return;
      root.dataset.astroHeaderInitialized = 'true';

      const utilityBar = root.querySelector('.utility-bar');
      const siteNav = root.querySelector('.site-nav');
      const navSurface = root.querySelector('.site-nav__surface');
      const backdrop = root.querySelector('.mega-menu__backdrop');
      const desktopTriggers = Array.from(root.querySelectorAll('[data-menu-trigger]'));
      const panels = Array.from(root.querySelectorAll('[data-menu-panel]'));
      const mobileToggle = root.querySelector('[data-mobile-menu-toggle]');
      const mobileDrawer = root.querySelector('[data-mobile-menu]');
      const mobileRootView = root.querySelector('[data-mobile-menu-view="root"]');
      const mobileDetailView = root.querySelector('[data-mobile-menu-view="detail"]');
      const mobileTopButtons = Array.from(root.querySelectorAll('[data-mobile-menu-open]'));
      const mobileBackButton = root.querySelector('[data-mobile-menu-back]');
      const mobileBackLabel = root.querySelector('[data-mobile-menu-back-label]');
      const mobileChevronTemplate = root.querySelector('template[id^="mobile-menu-chevron-right-template"]');
      const mobileTitle = root.querySelector('[data-mobile-menu-title]');
      const mobileList = root.querySelector('[data-mobile-menu-list]');
      const mobilePreviewMedia = root.querySelector('[data-mobile-menu-preview-media]');
      const mobilePreviewImage = root.querySelector('[data-mobile-menu-preview-image]');
      const mobilePreviewCopy = root.querySelector('[data-mobile-menu-preview-copy]');
      const searchOverlay = root.querySelector('[data-search-overlay]');
      const searchOpenButtons = Array.from(root.querySelectorAll('[data-search-overlay-open]'));
      const searchCloseButton = root.querySelector('[data-search-overlay-close]');
      const searchForm = root.querySelector('[data-search-overlay-form]');
      const searchInput = root.querySelector('[data-search-overlay-input]');
      const searchResults = root.querySelector('[data-search-overlay-results]');
      const searchSubmitButton = root.querySelector('[data-search-overlay-submit]');
      const searchStatus = root.querySelector('[data-search-overlay-status]');

      const syncHeaderHeight = () => {
        const headerHeight = (utilityBar?.offsetHeight || 0) + (siteNav?.offsetHeight || root.offsetHeight || 0);
        document.documentElement.style.setProperty('--site-header-height', `${headerHeight}px`);
      };

      syncHeaderHeight();
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(syncHeaderHeight);
        if (utilityBar) observer.observe(utilityBar);
        if (siteNav) observer.observe(siteNav);
      }

      let lastScrollY = window.scrollY;
      let headerInteracting = false;
      let headerFrame = null;

      const updateHeaderVisibility = () => {
        const currentScrollY = window.scrollY;
        const isPastThreshold = currentScrollY > 32;
        const isScrollingDown = currentScrollY > lastScrollY;
        const isMenuOpen =
          document.body.classList.contains('has-open-megamenu') ||
          document.body.classList.contains('has-open-mobile-menu') ||
          document.body.classList.contains('has-open-newsletter') ||
          document.body.classList.contains('has-open-search-overlay');

        document.body.classList.toggle('is-below-header-threshold', currentScrollY <= 32);
        document.body.classList.toggle(
          'has-hidden-site-header',
          isPastThreshold && isScrollingDown && !headerInteracting && !isMenuOpen,
        );
        lastScrollY = currentScrollY;
        headerFrame = null;
      };

      const queueHeaderVisibilityUpdate = () => {
        if (headerFrame !== null) return;
        headerFrame = window.requestAnimationFrame(updateHeaderVisibility);
      };

      root.addEventListener('pointerenter', () => {
        headerInteracting = true;
        document.body.classList.remove('has-hidden-site-header');
      });
      root.addEventListener('pointerleave', () => {
        headerInteracting = false;
        queueHeaderVisibilityUpdate();
      });
      root.addEventListener('focusin', () => {
        headerInteracting = true;
        document.body.classList.remove('has-hidden-site-header');
      });
      root.addEventListener('focusout', (event) => {
        if (event.relatedTarget instanceof Node && root.contains(event.relatedTarget)) return;
        headerInteracting = false;
        queueHeaderVisibilityUpdate();
      });
      window.addEventListener('scroll', queueHeaderVisibilityUpdate, { passive: true });
      updateHeaderVisibility();

      const closeExternalSurfacesForSearch = () => {
        document.dispatchEvent(new CustomEvent('franzi:close-filter-drawer'));
        document.querySelectorAll('[data-newsletter-overlay]').forEach((overlay) => {
          if (typeof overlay.franziNewsletterApi?.close === 'function') {
            overlay.franziNewsletterApi.close(false);
          }
        });
      };

      const initSearchOverlay = ({ closeLocalSurfaces = () => {} } = {}) => {
        if (
          !searchOverlay ||
          !searchForm ||
          !searchInput ||
          !searchResults ||
          !searchOpenButtons.length ||
          searchOverlay.dataset.searchOverlayInitialized === 'true'
        ) {
          return;
        }

        searchOverlay.dataset.searchOverlayInitialized = 'true';

        const searchCache = new Map();
        const minSearchLength = 2;
        const requestDelay = 220;
        let activeOptionIndex = -1;
        let closeTimer = null;
        let debounceTimer = null;
        let abortController = null;
        let isOpen = false;
        let lastFocusedTrigger = null;

        const getSearchTerm = () => searchInput.value.trim();
        const getOptions = () =>
          Array.from(searchResults.querySelectorAll('[data-search-overlay-option]')).filter(
            (option) => option instanceof HTMLElement && !option.closest('[hidden]'),
          );

        const setStatus = (message = '') => {
          if (!searchStatus) return;
          window.clearTimeout(searchStatus.dataset.statusTimer);
          searchStatus.textContent = message;
          searchStatus.setAttribute('aria-hidden', message ? 'false' : 'true');
          if (!message) return;

          const timer = window.setTimeout(() => {
            searchStatus.textContent = '';
            searchStatus.setAttribute('aria-hidden', 'true');
          }, 1000);
          searchStatus.dataset.statusTimer = String(timer);
        };

        const updateActiveOption = (index) => {
          const options = getOptions();
          if (!options.length) {
            activeOptionIndex = -1;
            searchInput.removeAttribute('aria-activedescendant');
            return;
          }

          activeOptionIndex = (index + options.length) % options.length;
          options.forEach((option, optionIndex) => {
            const isActive = optionIndex === activeOptionIndex;
            option.setAttribute('aria-selected', String(isActive));
            if (isActive && option.id) searchInput.setAttribute('aria-activedescendant', option.id);
          });
        };

        const resetActiveOption = () => {
          activeOptionIndex = -1;
          searchInput.removeAttribute('aria-activedescendant');
          getOptions().forEach((option) => option.setAttribute('aria-selected', 'false'));
        };

        const updateFieldControls = () => {
          const hasTerm = getSearchTerm().length > 0;
          if (searchSubmitButton) searchSubmitButton.disabled = !hasTerm;
        };

        const clearResults = () => {
          searchResults.replaceChildren();
          searchResults.classList.remove('is-loading');
          searchInput.setAttribute('aria-expanded', 'false');
          resetActiveOption();
        };

        const setResults = (html) => {
          searchResults.innerHTML = html;
          searchResults.classList.remove('is-loading');
          searchInput.setAttribute('aria-expanded', getOptions().length ? 'true' : 'false');
          resetActiveOption();
        };

        const buildSearchUrl = (term) => {
          const url = new URL(searchOverlay.dataset.predictiveSearchUrl || '/search/suggest', window.location.origin);
          url.searchParams.set('q', term);
          url.searchParams.set('section_id', searchOverlay.dataset.predictiveSearchSectionId || 'predictive-search');
          url.searchParams.set('resources[type]', 'product');
          url.searchParams.set('resources[limit]', '4');
          url.searchParams.set('resources[limit_scope]', 'all');
          url.searchParams.set('resources[options][unavailable_products]', 'hide');
          url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title');
          return url;
        };

        const fetchResults = async (term) => {
          const normalizedTerm = term.toLowerCase();
          if (searchCache.has(normalizedTerm)) {
            setResults(searchCache.get(normalizedTerm));
            return;
          }

          if (abortController) abortController.abort();
          const controller = new AbortController();
          abortController = controller;
          searchResults.classList.add('is-loading');
          setStatus(searchOverlay.dataset.searchLoadingLabel || '');

          try {
            const response = await window.fetch(buildSearchUrl(term).toString(), {
              signal: controller.signal,
              headers: { Accept: 'text/html' },
            });
            if (!response.ok) throw new Error(`Predictive search failed with ${response.status}`);

            const text = await response.text();
            const parsed = new DOMParser().parseFromString(text, 'text/html');
            const renderedSection =
              parsed.querySelector('#shopify-section-predictive-search') ||
              parsed.querySelector('[data-search-results]');
            const html = renderedSection ? renderedSection.innerHTML : '';

            searchCache.set(normalizedTerm, html);
            if (getSearchTerm().toLowerCase() === normalizedTerm) setResults(html);
          } catch (error) {
            if (controller.signal.aborted) return;
            clearResults();
          } finally {
            if (abortController === controller) abortController = null;
            setStatus('');
          }
        };

        const queueResultsFetch = () => {
          window.clearTimeout(debounceTimer);
          updateFieldControls();
          const term = getSearchTerm();

          if (term.length < minSearchLength) {
            clearResults();
            return;
          }

          debounceTimer = window.setTimeout(() => fetchResults(term), requestDelay);
        };

        const openSearchOverlay = (trigger) => {
          lastFocusedTrigger = trigger instanceof HTMLElement ? trigger : lastFocusedTrigger;
          closeLocalSurfaces();
          closeExternalSurfacesForSearch();

          window.clearTimeout(closeTimer);
          searchOverlay.hidden = false;
          searchOverlay.inert = false;
          searchOverlay.setAttribute('aria-hidden', 'false');
          searchOpenButtons.forEach((button) => button.setAttribute('aria-expanded', 'true'));
          document.body.classList.remove('has-hidden-site-header');
          document.body.classList.add('has-open-search-overlay');
          document.documentElement.classList.add('has-search-overlay-scroll-lock');
          isOpen = true;
          updateFieldControls();

          window.requestAnimationFrame(() => {
            searchOverlay.classList.add('is-open');
            searchInput.focus({ preventScroll: true });
            if (getSearchTerm().length >= minSearchLength && !searchResults.hasChildNodes()) queueResultsFetch();
            searchInput.setAttribute('aria-expanded', getOptions().length ? 'true' : 'false');
          });
        };

        const closeSearchOverlay = ({ focusTrigger = false } = {}) => {
          if (!isOpen) return;
          isOpen = false;
          window.clearTimeout(debounceTimer);
          if (abortController) abortController.abort();
          resetActiveOption();
          searchOverlay.classList.remove('is-open');
          searchOverlay.setAttribute('aria-hidden', 'true');
          searchOverlay.inert = true;
          searchInput.setAttribute('aria-expanded', 'false');
          searchOpenButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
          document.body.classList.remove('has-open-search-overlay');
          document.documentElement.classList.remove('has-search-overlay-scroll-lock');

          closeTimer = window.setTimeout(() => {
            if (!isOpen) searchOverlay.hidden = true;
          }, 240);

          if (focusTrigger) {
            window.requestAnimationFrame(() => lastFocusedTrigger?.focus({ preventScroll: true }));
          }
        };

        const activateOption = () => {
          const option = getOptions()[activeOptionIndex];
          if (!(option instanceof HTMLElement)) return false;
          const action = option.matches('a, button') ? option : option.querySelector('a, button');
          if (action instanceof HTMLElement) {
            action.click();
            return true;
          }
          return false;
        };

        searchOpenButtons.forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            openSearchOverlay(button);
          });
        });

        searchCloseButton?.addEventListener('click', () => closeSearchOverlay({ focusTrigger: true }));

        searchForm.addEventListener('submit', (event) => {
          if (getSearchTerm().length > 0) return;
          event.preventDefault();
          clearResults();
        });

        searchInput.addEventListener('input', queueResultsFetch);

        searchInput.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowDown') {
            event.preventDefault();
            updateActiveOption(activeOptionIndex + 1);
            return;
          }

          if (event.key === 'ArrowUp') {
            event.preventDefault();
            updateActiveOption(activeOptionIndex - 1);
            return;
          }

          if (event.key === 'Enter' && activeOptionIndex >= 0 && activateOption()) {
            event.preventDefault();
          }
        });

        searchOverlay.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            event.preventDefault();
            closeSearchOverlay({ focusTrigger: true });
            return;
          }

          if (event.key !== 'Tab') return;
          const focusableElements = Array.from(searchOverlay.querySelectorAll(focusableSelector)).filter(
            (element) =>
              element instanceof HTMLElement &&
              !element.hidden &&
              !element.closest('[hidden]') &&
              getComputedStyle(element).visibility !== 'hidden',
          );
          if (!focusableElements.length) {
            event.preventDefault();
            return;
          }

          const first = focusableElements[0];
          const last = focusableElements[focusableElements.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        });

        searchOverlay.addEventListener('focusout', (event) => {
          if (!isOpen || (event.relatedTarget instanceof Node && searchOverlay.contains(event.relatedTarget))) return;
          window.requestAnimationFrame(() => {
            if (isOpen && !searchOverlay.contains(document.activeElement)) {
              searchInput.focus({ preventScroll: true });
            }
          });
        });

        searchResults.addEventListener('pointermove', (event) => {
          if (!(event.target instanceof Element)) return;
          const option = event.target.closest('[data-search-overlay-option]');
          if (!(option instanceof HTMLElement)) return;
          const options = getOptions();
          const index = options.indexOf(option);
          if (index >= 0) updateActiveOption(index);
        });

        updateFieldControls();
        searchOverlay.inert = true;
      };

      if (!navSurface || !backdrop || !desktopTriggers.length || !panels.length) {
        initSearchOverlay();
        return;
      }

      const panelsByMenu = new Map(panels.map((panel) => [panel.dataset.menuPanel, panel]));
      const triggersByMenu = new Map(desktopTriggers.map((trigger) => [trigger.dataset.menuTrigger, trigger]));
      const menuModelsById = new Map(
        panels.map((panel) => {
          const menuId = panel.dataset.menuPanel;
          const branches = Array.from(panel.querySelectorAll('.mega-menu__branch-trigger')).map((branch) => {
            const branchId = branch.dataset.branch;
            const leafGroup = panel.querySelector(`[data-branch-panel="${branchId}"]`);
            const leaves = leafGroup
              ? Array.from(leafGroup.querySelectorAll('.mega-menu__leaf-trigger')).map((leaf) => ({
                  id: leaf.dataset.leaf,
                  label: leaf.textContent.trim(),
                  preview: getElementPreview(leaf),
                }))
              : [];

            return {
              id: branchId,
              label: branch.textContent.trim(),
              preview: getElementPreview(branch),
              leaves,
            };
          });

          return [
            menuId,
            {
              id: menuId,
              label: panel.dataset.menuLabel || menuId,
              preview: getElementPreview(panel),
              branches,
            },
          ];
        }),
      );

      const state = {
        openMenu: null,
        hoverPreview: null,
        menus: Object.fromEntries(panels.map((panel) => [panel.dataset.menuPanel, { visibleBranch: '' }])),
        mobile: {
          isOpen: false,
          activeMenu: null,
          activeLevel: 'root',
          activeBranch: '',
          activeLeaf: '',
        },
      };
      let mobileStepFrame = null;
      let mobileStepTimer = null;

      const getLeafGroup = (panel, branchId) => panel.querySelector(`[data-branch-panel="${branchId}"]`);

      const getBranchButton = (panel, branchId) => panel.querySelector(`[data-branch="${branchId}"]`);

      const setPanelVisibility = (panel, isOpen) => {
        panel.inert = !isOpen;
        panel.setAttribute('aria-hidden', String(!isOpen));
        panel.hidden = !isOpen;
        panel.classList.toggle('is-open', isOpen);
      };

      const setPreview = (panel, sourceElement) => {
        const imageElement = panel.querySelector('.mega-menu__preview-image');
        const copyElement = panel.querySelector('.mega-menu__preview-copy');
        const linkElement = panel.querySelector('.mega-menu__preview-link');
        if (!imageElement || !copyElement || !sourceElement) return;

        const preview = getElementPreview(sourceElement);
        if (preview.image) imageElement.src = preview.image;
        imageElement.alt = preview.alt;
        if (preview.html) {
          copyElement.innerHTML = preview.html;
        } else {
          copyElement.textContent = preview.description;
        }

        if (linkElement && preview.href) {
          linkElement.href = preview.href;
          linkElement.setAttribute(
            'aria-label',
            preview.linkLabel || sourceElement.textContent?.trim() || 'Vai alla pagina',
          );
        }
      };

      const renderPanel = (panel) => {
        const menuId = panel.dataset.menuPanel;
        const isOpen = state.openMenu === menuId;
        const menuState = state.menus[menuId];
        const hoveredElement = state.hoverPreview?.menuId === menuId ? state.hoverPreview.element : null;
        let visibleBranch = menuState.visibleBranch;

        if (hoveredElement instanceof HTMLElement && panel.contains(hoveredElement)) {
          if (hoveredElement.hasAttribute('data-branch')) visibleBranch = hoveredElement.dataset.branch || '';
          if (hoveredElement.hasAttribute('data-leaf')) visibleBranch = hoveredElement.dataset.parentBranch || '';
        }

        setPanelVisibility(panel, isOpen);

        panel.querySelectorAll('[data-branch]').forEach((branch) => {
          const branchId = branch.dataset.branch;
          const isActive = visibleBranch === branchId || hoveredElement === branch;
          branch.classList.toggle('is-active', isActive);
          if (branch.hasAttribute('aria-expanded')) {
            branch.setAttribute('aria-expanded', String(visibleBranch === branchId));
          }
        });

        panel.querySelectorAll('[data-branch-panel]').forEach((leafGroup) => {
          leafGroup.hidden = visibleBranch !== leafGroup.dataset.branchPanel;
        });

        panel.querySelectorAll('[data-leaf]').forEach((leaf) => {
          leaf.classList.toggle('is-active', hoveredElement === leaf);
        });

        setPreview(panel, hoveredElement || panel);
      };

      const renderMenus = () => {
        panels.forEach(renderPanel);
        desktopTriggers.forEach((trigger) => {
          const isOpen = state.openMenu === trigger.dataset.menuTrigger;
          trigger.classList.toggle('is-open', isOpen);
          trigger.setAttribute('aria-expanded', String(isOpen));
        });
        document.body.classList.toggle('has-open-megamenu', Boolean(state.openMenu));
      };

      const openMenu = (menuId) => {
        if (mobileMenuQuery.matches) return;
        state.openMenu = menuId;
        state.hoverPreview = null;
        Object.values(state.menus).forEach((menuState) => {
          menuState.visibleBranch = '';
        });
        renderMenus();

        const panel = panelsByMenu.get(menuId);
        if (panel instanceof HTMLElement) {
          window.requestAnimationFrame(() => {
            if (state.openMenu === menuId) panel.focus({ preventScroll: true });
          });
        }
      };

      const closeMenu = ({ focusTrigger = false } = {}) => {
        const openTrigger = state.openMenu ? triggersByMenu.get(state.openMenu) : null;
        state.openMenu = null;
        state.hoverPreview = null;
        Object.values(state.menus).forEach((menuState) => {
          menuState.visibleBranch = '';
        });
        renderMenus();
        if (focusTrigger) openTrigger?.focus();
      };

      const getPanelFocusableElements = (panel) =>
        Array.from(panel.querySelectorAll(focusableSelector)).filter(
          (element) => element instanceof HTMLElement && !element.closest('[hidden]'),
        );

      const cloneMobileChevron = () => {
        if (!(mobileChevronTemplate instanceof HTMLTemplateElement)) return null;
        return mobileChevronTemplate.content.firstElementChild?.cloneNode(true) || null;
      };

      const createMobileListItem = ({
        label,
        isActive = false,
        hasChildren = false,
        asLink = false,
        href = '#',
        onClick,
      }) => {
        const listItem = document.createElement('li');
        const action = document.createElement(asLink ? 'a' : 'button');

        if (asLink) {
          action.href = href;
          action.className = 'mobile-menu__detail-link';
          if (onClick) {
            action.addEventListener('click', (event) => {
              if (href === '#' || href.startsWith('#') || href.endsWith('#')) event.preventDefault();
              onClick(event);
            });
          }
        } else {
          action.type = 'button';
          action.className = 'mobile-menu__detail-button';
          action.addEventListener('click', onClick);
          action.setAttribute('aria-pressed', String(isActive));
        }

        action.classList.toggle('is-active', isActive);

        action.append(label);
        action.dataset.hasChildren = hasChildren ? 'true' : 'false';
        if (hasChildren) {
          const icon = cloneMobileChevron();
          if (icon) action.append(icon);
        }

        listItem.append(action);
        return listItem;
      };

      const getActiveMobileMenu = () => (state.mobile.activeMenu ? menuModelsById.get(state.mobile.activeMenu) : null);
      const getActiveMobileBranch = () => {
        const menu = getActiveMobileMenu();
        return menu?.branches.find((branch) => branch.id === state.mobile.activeBranch) || null;
      };

      const animateMobileStep = (direction = 'forward') => {
        if (!mobileDrawer) return;
        mobileDrawer.dataset.mobileMenuDirection = direction;
        mobileDrawer.classList.remove('is-stepping');
        if (mobileStepFrame !== null) window.cancelAnimationFrame(mobileStepFrame);
        if (mobileStepTimer !== null) window.clearTimeout(mobileStepTimer);
        void mobileDrawer.offsetWidth;
        mobileStepFrame = window.requestAnimationFrame(() => {
          mobileDrawer.classList.add('is-stepping');
          mobileStepTimer = window.setTimeout(() => {
            mobileDrawer.classList.remove('is-stepping');
            mobileStepTimer = null;
          }, 520);
          mobileStepFrame = null;
        });
      };

      const renderMobileMenu = ({ stepDirection = '' } = {}) => {
        if (!mobileToggle || !mobileDrawer || !mobileRootView || !mobileDetailView) return;

        const isOpen = state.mobile.isOpen;
        const isRoot = !state.mobile.activeMenu;
        mobileDrawer.hidden = !isOpen;
        mobileRootView.hidden = !isOpen || !isRoot;
        mobileDetailView.hidden = !isOpen || isRoot;
        mobileToggle.setAttribute('aria-expanded', String(isOpen));
        mobileToggle.setAttribute('aria-label', isOpen ? 'Chiudi il menu' : 'Apri il menu');
        document.body.classList.toggle('has-open-mobile-menu', isOpen);

        mobileTopButtons.forEach((button) => {
          button.setAttribute(
            'aria-expanded',
            String(isOpen && state.mobile.activeMenu === button.dataset.mobileMenuOpen),
          );
        });

        if (!isOpen) {
          mobileDrawer.classList.remove('is-stepping');
          delete mobileDrawer.dataset.mobileMenuDirection;
          return;
        }
        if (isRoot) {
          if (stepDirection) animateMobileStep(stepDirection);
          return;
        }

        const menu = getActiveMobileMenu();
        const branch = getActiveMobileBranch();
        if (!menu || !mobileTitle || !mobileList) return;

        const isLeafLevel = state.mobile.activeLevel === 'leaf';
        const items = isLeafLevel && branch ? branch.leaves : menu.branches;

        if (mobileBackLabel) mobileBackLabel.textContent = isLeafLevel ? menu.label : 'Indietro';
        mobileBackButton?.setAttribute(
          'aria-label',
          isLeafLevel ? `Torna a ${menu.label}` : 'Torna al menu principale',
        );
        mobileTitle.textContent = isLeafLevel && branch ? branch.label : menu.label;
        mobileList.setAttribute('aria-label', isLeafLevel && branch ? branch.label : menu.label);
        mobileList.classList.toggle('mobile-menu__detail-list--leaf', isLeafLevel);

        const listItems = items.map((item) => {
          if (isLeafLevel && branch) {
            return createMobileListItem({
              label: item.label,
              asLink: true,
              href: item.href || item.preview?.href || '#',
            });
          }

          return createMobileListItem({
            label: item.label,
            isActive: state.mobile.activeBranch === item.id,
            hasChildren: item.leaves.length > 0,
            asLink: item.leaves.length === 0,
            href: item.preview?.href || '#',
            onClick: () => {
              if (item.leaves.length === 0) return;
              state.mobile.activeBranch = item.id;
              state.mobile.activeLeaf = '';
              state.mobile.activeLevel = 'leaf';
              renderMobileMenu({ stepDirection: 'forward' });
              window.requestAnimationFrame(() => mobileBackButton?.focus());
            },
          });
        });

        // Feedbucket #129: append a separated "Vai alla pagina X" item as the
        // last row of the detail list, pointing to the parent's own page. The
        // parent is the current detail view's subject: the branch at leaf level,
        // otherwise the menu itself. Skip it when that parent has no page URL.
        const parentPage = isLeafLevel && branch ? branch : menu;
        const parentPageHref = parentPage?.preview?.href || '';
        if (
          parentPageHref &&
          parentPageHref !== '#' &&
          !parentPageHref.startsWith('#') &&
          !parentPageHref.endsWith('#')
        ) {
          const pageLinkLabel =
            parentPage?.preview?.pageLinkLabel || mobileList.dataset.pageLinkLabel || 'Vai alla pagina';
          const pageItem = createMobileListItem({
            label: `${pageLinkLabel} ${parentPage.label.toLowerCase() || ''}`.trim(),
            asLink: true,
            href: parentPageHref,
          });
          pageItem.classList.add('mobile-menu__detail-item--page');
          listItems.push(pageItem);
        }

        mobileList.replaceChildren(...listItems);
        if (stepDirection) animateMobileStep(stepDirection);
      };

      const openMobileRoot = ({ focusFirstItem = false, stepDirection = 'forward' } = {}) => {
        if (!mobileMenuQuery.matches) return;
        state.mobile.isOpen = true;
        state.mobile.activeMenu = null;
        state.mobile.activeLevel = 'root';
        state.mobile.activeBranch = '';
        state.mobile.activeLeaf = '';
        renderMobileMenu({ stepDirection });
        if (focusFirstItem) window.requestAnimationFrame(() => mobileTopButtons[0]?.focus());
      };

      const openMobileDetail = (menuId) => {
        if (!mobileMenuQuery.matches || !menuModelsById.has(menuId)) return;
        state.mobile.isOpen = true;
        state.mobile.activeMenu = menuId;
        state.mobile.activeLevel = 'branch';
        state.mobile.activeBranch = '';
        state.mobile.activeLeaf = '';
        renderMobileMenu({ stepDirection: 'forward' });
        window.requestAnimationFrame(() => mobileBackButton?.focus());
      };

      const closeMobile = ({ focusToggle = false } = {}) => {
        if (!state.mobile.isOpen) return;
        state.mobile.isOpen = false;
        state.mobile.activeMenu = null;
        state.mobile.activeLevel = 'root';
        state.mobile.activeBranch = '';
        state.mobile.activeLeaf = '';
        renderMobileMenu();
        if (focusToggle) mobileToggle?.focus();
      };

      initSearchOverlay({
        closeLocalSurfaces: () => {
          if (state.openMenu) closeMenu();
          if (state.mobile.isOpen) closeMobile();
        },
      });

      desktopTriggers.forEach((trigger) => {
        const menuId = trigger.dataset.menuTrigger;
        trigger.addEventListener('click', () => {
          if (state.openMenu === menuId) {
            closeMenu();
            return;
          }
          openMenu(menuId);
        });
        trigger.addEventListener('keydown', (event) => {
          if (event.key !== 'Tab' || event.shiftKey || state.openMenu !== menuId) return;
          const panel = panelsByMenu.get(menuId);
          const focusable = panel ? getPanelFocusableElements(panel) : [];
          if (focusable.length) {
            event.preventDefault();
            focusable[0].focus();
          }
        });
      });

      panels.forEach((panel) => {
        const menuId = panel.dataset.menuPanel;
        panel.querySelectorAll('[data-branch]').forEach((branch) => {
          const activate = () => {
            if (state.openMenu !== menuId) return;
            const branchId = branch.dataset.branch;
            state.menus[menuId].visibleBranch = getLeafGroup(panel, branchId) ? branchId : '';
            state.hoverPreview = { menuId, element: branch };
            renderPanel(panel);
          };
          branch.addEventListener('pointerenter', activate);
          branch.addEventListener('focus', activate);
          branch.addEventListener('keydown', (event) => {
            if (event.key !== 'Tab' || event.shiftKey || state.openMenu !== menuId) return;
            const firstLeaf = getLeafGroup(panel, branch.dataset.branch)?.querySelector(focusableSelector);
            if (firstLeaf instanceof HTMLElement) {
              event.preventDefault();
              firstLeaf.focus();
            }
          });
        });

        panel.querySelectorAll('[data-leaf]').forEach((leaf) => {
          const activate = () => {
            if (state.openMenu !== menuId) return;
            const parentBranch = leaf.dataset.parentBranch || '';
            if (parentBranch) state.menus[menuId].visibleBranch = parentBranch;
            state.hoverPreview = { menuId, element: leaf };
            renderPanel(panel);
          };
          leaf.addEventListener('pointerenter', activate);
          leaf.addEventListener('focus', activate);
          leaf.addEventListener('keydown', (event) => {
            if (event.key !== 'Tab' || state.openMenu !== menuId) return;
            const leafGroup = leaf.closest('[data-branch-panel]');
            if (!leafGroup) return;
            const leaves = Array.from(leafGroup.querySelectorAll(focusableSelector));
            const branch = getBranchButton(panel, leafGroup.dataset.branchPanel);
            if (event.shiftKey && leaves[0] === leaf && branch instanceof HTMLElement) {
              event.preventDefault();
              branch.focus();
            }
          });
        });

        panel.addEventListener('keydown', (event) => {
          if (event.key !== 'Tab' || !event.shiftKey || state.openMenu !== menuId) return;
          const focusable = getPanelFocusableElements(panel);
          if (document.activeElement === panel || document.activeElement === focusable[0]) {
            event.preventDefault();
            triggersByMenu.get(menuId)?.focus();
          }
        });
      });

      mobileToggle?.addEventListener('click', () => {
        if (!mobileMenuQuery.matches) return;
        if (state.mobile.isOpen) {
          closeMobile();
          return;
        }
        openMobileRoot({ focusFirstItem: true, stepDirection: 'forward' });
      });

      mobileTopButtons.forEach((button) => {
        button.addEventListener('click', () => openMobileDetail(button.dataset.mobileMenuOpen));
      });

      mobileBackButton?.addEventListener('click', () => {
        if (state.mobile.activeLevel === 'leaf') {
          state.mobile.activeLevel = 'branch';
          state.mobile.activeBranch = '';
          renderMobileMenu({ stepDirection: 'back' });
          window.requestAnimationFrame(() => mobileBackButton.focus());
          return;
        }
        openMobileRoot({ focusFirstItem: true, stepDirection: 'back' });
      });

      backdrop.addEventListener('click', () => closeMenu());

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        if (state.openMenu) {
          event.preventDefault();
          closeMenu({ focusTrigger: true });
          return;
        }
        if (state.mobile.isOpen) {
          event.preventDefault();
          closeMobile({ focusToggle: true });
        }
      });

      document.addEventListener('pointerdown', (event) => {
        if (!state.openMenu || navSurface.contains(event.target) || event.target === backdrop) return;
        closeMenu();
      });

      // Feedbucket #260: close the open desktop mega menu when the pointer
      // leaves the nav surface (trigger row + open panel are both descendants
      // of navSurface, so moving between them does not fire this). Restricted to
      // hover/fine-pointer desktop input so touch taps and keyboard focus are
      // unaffected. A short grace timer absorbs brief exits so the menu does not
      // flap shut; re-entering the surface cancels it.
      const hoverPointerQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
      let megaMenuCloseTimer = null;
      const cancelMegaMenuCloseTimer = () => {
        if (megaMenuCloseTimer !== null) {
          window.clearTimeout(megaMenuCloseTimer);
          megaMenuCloseTimer = null;
        }
      };
      navSurface.addEventListener('pointerleave', (event) => {
        if (event.pointerType && event.pointerType !== 'mouse') return;
        if (!hoverPointerQuery.matches || mobileMenuQuery.matches || !state.openMenu) return;
        cancelMegaMenuCloseTimer();
        megaMenuCloseTimer = window.setTimeout(() => {
          megaMenuCloseTimer = null;
          // Keep the menu open only if keyboard focus is on interactive panel
          // *content* (a branch/leaf the user tabbed to), so a mixed
          // mouse/keyboard user is never dropped out of a focused panel. The
          // panel container is auto-focused on open and the trigger sits
          // outside the panels, so neither blocks a normal mouse-driven close.
          const active = document.activeElement;
          const focusedPanel = active instanceof Element ? active.closest('[data-menu-panel]') : null;
          if (focusedPanel && active !== focusedPanel) return;
          if (state.openMenu && !mobileMenuQuery.matches) closeMenu();
        }, 260);
      });
      navSurface.addEventListener('pointerenter', cancelMegaMenuCloseTimer);

      const handleBreakpointChange = (event) => {
        cancelMegaMenuCloseTimer();
        if (event.matches) {
          closeMenu();
          return;
        }
        closeMobile();
      };

      if (typeof mobileMenuQuery.addEventListener === 'function') {
        mobileMenuQuery.addEventListener('change', handleBreakpointChange);
      } else {
        mobileMenuQuery.addListener(handleBreakpointChange);
      }

      renderMenus();
      renderMobileMenu();
    };

    const initAllHeaders = () => {
      document.querySelectorAll('[data-site-header]').forEach(initHeader);
    };

    initAllHeaders();
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll?.('[data-site-header]').forEach(initHeader);
    });
    document.addEventListener('shopify:block:select', (event) => {
      const panel = event.target.closest?.('[data-menu-panel]');
      if (panel instanceof HTMLElement) {
        const trigger = document.querySelector(`[data-menu-trigger="${panel.dataset.menuPanel}"]`);
        trigger?.click();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["heritage-timeline"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initTimeline = (root) => {
      if (!root || root.dataset.timelineInitialized === 'true') return;

      root.dataset.timelineInitialized = 'true';

      const links = Array.from(root.querySelectorAll('[data-timeline-nav-link]'));
      const years = Array.from(root.querySelectorAll('[data-timeline-year]'));

      if (!links.length || !years.length) return;

      const setCurrent = (id) => {
        links.forEach((link) => {
          const isCurrent = link.getAttribute('href') === `#${id}`;
          if (isCurrent) {
            link.setAttribute('aria-current', 'true');
          } else {
            link.removeAttribute('aria-current');
          }
        });
      };

      links.forEach((link) => {
        link.addEventListener('click', () => {
          const targetId = link.getAttribute('href')?.slice(1);
          if (targetId) setCurrent(targetId);
        });
      });

      if (!('IntersectionObserver' in window)) {
        setCurrent(years[0].id);
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

          if (visible?.target?.id) {
            setCurrent(visible.target.id);
          }
        },
        { rootMargin: '-35% 0px -55% 0px', threshold: [0.1, 0.35, 0.6] },
      );

      years.forEach((year) => observer.observe(year));
    };

    const initAll = () => {
      document.querySelectorAll('[data-heritage-timeline]').forEach(initTimeline);
    };

    initAll();

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll?.('[data-heritage-timeline]').forEach(initTimeline);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  class FranziFacetedGrid extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound === 'true') return;
      this.dataset.bound = 'true';
      this.addEventListener('submit', this.onSubmit.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('click', this.onClick.bind(this));
      window.addEventListener('popstate', () => this.renderUrl(window.location.href, false));
    }

    onChange(event) {
      const form = event.target.closest('[data-facet-form], [data-sort-form]');
      if (form) form.requestSubmit();
    }

    onSubmit(event) {
      const form = event.target.closest('[data-facet-form], [data-sort-form]');
      if (!form) return;
      event.preventDefault();
      const url = new URL(form.action, window.location.origin);
      const formData = new FormData(form);
      for (const [key, value] of formData.entries()) {
        if (String(value).trim() !== '') url.searchParams.append(key, value);
      }
      this.renderUrl(url.toString(), true);
    }

    onClick(event) {
      const link = event.target.closest('a[href]');
      if (!link || !this.contains(link)) return;
      const url = new URL(link.href, window.location.origin);
      if (url.origin !== window.location.origin) return;
      if (!url.pathname.includes('/collections/') && url.pathname !== '/search') return;
      event.preventDefault();
      this.renderUrl(url.toString(), true);
    }

    async renderUrl(url, pushState) {
      const targetUrl = new URL(url, window.location.origin);
      targetUrl.searchParams.set('section_id', this.dataset.sectionId);
      this.classList.add('is-loading');

      try {
        const response = await fetch(targetUrl.toString(), {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });
        if (!response.ok) throw new Error(`Section render failed: ${response.status}`);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const next = doc.querySelector(`franzi-faceted-grid[data-section-id="${this.dataset.sectionId}"]`);
        if (!next) throw new Error('Missing faceted grid in section response');
        this.replaceWith(next);
        if (pushState) {
          targetUrl.searchParams.delete('section_id');
          window.history.pushState({}, '', targetUrl.toString());
        }
      } catch (error) {
        window.location.href = url;
      }
    }
  }

  if (!customElements.get('franzi-faceted-grid')) {
    customElements.define('franzi-faceted-grid', FranziFacetedGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  class FranziFacetedGrid extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound === 'true') return;
      this.dataset.bound = 'true';
      this.addEventListener('submit', this.onSubmit.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('click', this.onClick.bind(this));
      window.addEventListener('popstate', () => this.renderUrl(window.location.href, false));
    }

    onChange(event) {
      const form = event.target.closest('[data-facet-form], [data-sort-form]');
      if (form) form.requestSubmit();
    }

    onSubmit(event) {
      const form = event.target.closest('[data-search-form], [data-facet-form], [data-sort-form]');
      if (!form) return;
      event.preventDefault();
      const url = new URL(form.action, window.location.origin);
      const formData = new FormData(form);
      for (const [key, value] of formData.entries()) {
        if (String(value).trim() !== '') url.searchParams.append(key, value);
      }
      this.renderUrl(url.toString(), true);
    }

    onClick(event) {
      const link = event.target.closest('a[href]');
      if (!link || !this.contains(link)) return;
      const url = new URL(link.href, window.location.origin);
      if (url.origin !== window.location.origin) return;
      if (!url.pathname.includes('/collections/') && url.pathname !== '/search') return;
      event.preventDefault();
      this.renderUrl(url.toString(), true);
    }

    async renderUrl(url, pushState) {
      const targetUrl = new URL(url, window.location.origin);
      targetUrl.searchParams.set('section_id', this.dataset.sectionId);
      this.classList.add('is-loading');

      try {
        const response = await fetch(targetUrl.toString(), {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });
        if (!response.ok) throw new Error(`Section render failed: ${response.status}`);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const next = doc.querySelector(`franzi-faceted-grid[data-section-id="${this.dataset.sectionId}"]`);
        if (!next) throw new Error('Missing faceted grid in section response');
        this.replaceWith(next);
        if (pushState) {
          targetUrl.searchParams.delete('section_id');
          window.history.pushState({}, '', targetUrl.toString());
        }
      } catch (error) {
        window.location.href = url;
      }
    }
  }

  if (!customElements.get('franzi-faceted-grid')) {
    customElements.define('franzi-faceted-grid', FranziFacetedGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-overlay"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const focusableSelector = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])',
    ].join(',');

    const getNewsletterFocusableElements = (container) =>
      Array.from(container.querySelectorAll(focusableSelector)).filter((element) => {
        if (!(element instanceof HTMLElement)) return false;
        if (element.hidden || element.getAttribute('aria-hidden') === 'true') return false;
        return element.offsetParent !== null || element === document.activeElement;
      });

    const newsletterToastDismissed = 'franzi_newsletter_toast_dismissed';
    const newsletterToastCookieMaxAge = 60 * 60 * 24 * 365;
    const newsletterToastRevealDelay = 1000;
    const newsletterToastMaxRevealDelay = 5000;

    const hasNewsletterCookie = (name) =>
      document.cookie.split(';').some((cookie) => cookie.trim().startsWith(`${name}=`));

    const setNewsletterCookie = (name, value, maxAge) => {
      const secureCookie = window.location.protocol === 'https:' ? '; Secure' : '';
      document.cookie = `${name}=${value}; Max-Age=${maxAge}; Path=/; SameSite=Lax${secureCookie}`;
    };

    const initNewsletterOverlay = (newsletterOverlay) => {
      if (!newsletterOverlay || newsletterOverlay.dataset.newsletterInitialized === 'true') return;

      newsletterOverlay.dataset.newsletterInitialized = 'true';

      const newsletterCloseButtons = Array.from(newsletterOverlay.querySelectorAll('[data-newsletter-close]'));
      const newsletterPanels = Array.from(newsletterOverlay.querySelectorAll('[data-newsletter-panel]'));
      let activeNewsletterPanel = null;
      let newsletterRestoreFocusTarget = null;

      const newsletterOpenButtons = () => Array.from(document.querySelectorAll('[data-newsletter-open]'));

      const setNewsletterOpenState = (panelId, trigger = null, restoreFocus = true) => {
        const isOpen = Boolean(panelId);

        if (isOpen && newsletterOverlay.hidden && trigger) {
          newsletterRestoreFocusTarget = trigger;
        } else if (isOpen && trigger && !newsletterOverlay.contains(trigger)) {
          newsletterRestoreFocusTarget = trigger;
        }

        newsletterOverlay.hidden = !isOpen;
        newsletterOverlay.classList.toggle('is-open', isOpen);
        newsletterOverlay.setAttribute('aria-hidden', String(!isOpen));
        document.body.classList.toggle('has-open-newsletter', isOpen);

        newsletterPanels.forEach((panel) => {
          const isActive = isOpen && panel.dataset.newsletterPanel === panelId;

          panel.hidden = !isActive;
          panel.inert = !isActive;
          panel.setAttribute('aria-hidden', String(!isActive));

          if (isActive) {
            activeNewsletterPanel = panel;
          }
        });

        newsletterOpenButtons().forEach((button) => {
          const targetPanel = button.dataset.newsletterOpen || 'drawer';
          button.setAttribute('aria-expanded', String(isOpen && targetPanel === panelId));
        });

        if (!isOpen) {
          const focusTarget = newsletterRestoreFocusTarget;

          activeNewsletterPanel = null;
          newsletterRestoreFocusTarget = null;

          if (restoreFocus && focusTarget instanceof HTMLElement) {
            focusTarget.focus();
          }

          return;
        }

        window.requestAnimationFrame(() => {
          const initialFocus = activeNewsletterPanel?.querySelector('[data-newsletter-initial-focus]');
          const closeButton = activeNewsletterPanel?.querySelector('[data-newsletter-close]');
          const firstFocusable =
            initialFocus ||
            closeButton ||
            getNewsletterFocusableElements(activeNewsletterPanel || newsletterOverlay)[0];

          firstFocusable?.focus();
        });
      };

      const closeNewsletter = (restoreFocus = true) => {
        setNewsletterOpenState('', null, restoreFocus);
      };

      newsletterCloseButtons.forEach((button) => {
        button.addEventListener('click', () => {
          closeNewsletter();
        });
      });

      document.addEventListener('click', (event) => {
        const button = event.target.closest?.('[data-newsletter-open]');
        if (!button) return;

        event.preventDefault();
        setNewsletterOpenState(button.dataset.newsletterOpen || 'drawer', button);
      });

      document.addEventListener('keydown', (event) => {
        if (newsletterOverlay.hidden || !activeNewsletterPanel) {
          return;
        }

        if (event.key === 'Escape') {
          event.preventDefault();
          closeNewsletter();
          return;
        }

        if (event.key !== 'Tab') {
          return;
        }

        const focusableElements = getNewsletterFocusableElements(activeNewsletterPanel);

        if (!focusableElements.length) {
          return;
        }

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (event.shiftKey && document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      });

      newsletterOverlay.franziNewsletterApi = {
        open: (panelId = 'drawer') => setNewsletterOpenState(panelId),
        close: closeNewsletter,
      };
    };

    const initNewsletterToast = (newsletterToast) => {
      if (!newsletterToast || newsletterToast.dataset.newsletterToastInitialized === 'true') return;

      newsletterToast.dataset.newsletterToastInitialized = 'true';

      const newsletterToastCloseButtons = Array.from(newsletterToast.querySelectorAll('[data-newsletter-toast-close]'));
      const newsletterToastOpenButtons = Array.from(newsletterToast.querySelectorAll('[data-newsletter-open]'));
      const isDesignMode = newsletterToast.dataset.newsletterDesignMode === 'true' || window.Shopify?.designMode;
      const newsletterToastMobileQuery = window.matchMedia('(max-width: 48rem)');
      let newsletterToastRevealTimer = null;
      let newsletterToastRevealScheduled = false;

      const closeNewsletterToast = () => {
        window.removeEventListener('scroll', revealNewsletterToastAfterMobileScroll);

        if (newsletterToastRevealTimer !== null) {
          window.clearTimeout(newsletterToastRevealTimer);
          newsletterToastRevealTimer = null;
        }

        newsletterToast.hidden = true;
        newsletterToast.classList.remove('is-open');
        newsletterToast.setAttribute('aria-hidden', 'true');
        setNewsletterCookie(newsletterToastDismissed, 'true', newsletterToastCookieMaxAge);
      };

      const revealNewsletterToast = () => {
        window.removeEventListener('scroll', revealNewsletterToastAfterMobileScroll);

        if (hasNewsletterCookie(newsletterToastDismissed)) {
          return;
        }

        newsletterToast.hidden = false;
        newsletterToast.classList.add('is-open');
        newsletterToast.setAttribute('aria-hidden', 'false');
      };

      const scheduleNewsletterToastReveal = () => {
        if (newsletterToastRevealScheduled) return;

        newsletterToastRevealScheduled = true;
        const startTime = window.performance?.now?.() ?? Date.now();

        const scheduleFromDomReady = () => {
          const currentTime = window.performance?.now?.() ?? Date.now();
          const elapsed = Math.max(0, currentTime - startTime);
          const remainingMaxDelay = Math.max(0, newsletterToastMaxRevealDelay - elapsed);
          const revealDelay = Math.min(newsletterToastRevealDelay, remainingMaxDelay);

          newsletterToastRevealTimer = window.setTimeout(revealNewsletterToast, revealDelay);
        };

        const maxRevealTimer = window.setTimeout(() => {
          if (newsletterToastRevealTimer !== null) {
            window.clearTimeout(newsletterToastRevealTimer);
          }

          newsletterToastRevealTimer = null;
          revealNewsletterToast();
        }, newsletterToastMaxRevealDelay);

        if (document.readyState === 'loading') {
          document.addEventListener(
            'DOMContentLoaded',
            () => {
              window.clearTimeout(maxRevealTimer);
              scheduleFromDomReady();
            },
            { once: true },
          );
          return;
        }

        window.clearTimeout(maxRevealTimer);
        scheduleFromDomReady();
      };

      function revealNewsletterToastAfterMobileScroll() {
        if (window.scrollY >= window.innerHeight * 0.5) {
          scheduleNewsletterToastReveal();
        }
      }

      newsletterToastCloseButtons.forEach((button) => {
        button.addEventListener('click', closeNewsletterToast);
      });

      newsletterToastOpenButtons.forEach((button) => {
        button.addEventListener('click', closeNewsletterToast);
      });

      if (isDesignMode || hasNewsletterCookie(newsletterToastDismissed)) {
        return;
      }

      if (newsletterToastMobileQuery.matches) {
        window.addEventListener('scroll', revealNewsletterToastAfterMobileScroll, { passive: true });
        revealNewsletterToastAfterMobileScroll();
      } else {
        scheduleNewsletterToastReveal();
      }
    };

    const initAllNewsletterOverlays = () => {
      document.querySelectorAll('[data-newsletter-overlay]').forEach(initNewsletterOverlay);
    };

    const initAllNewsletterToasts = () => {
      document.querySelectorAll('[data-newsletter-toast]').forEach(initNewsletterToast);
    };

    initAllNewsletterOverlays();
    initAllNewsletterToasts();

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll?.('[data-newsletter-overlay]').forEach(initNewsletterOverlay);
      event.target.querySelectorAll?.('[data-newsletter-toast]').forEach(initNewsletterToast);
    });

    document.addEventListener('shopify:section:unload', () => {
      document.body.classList.remove('has-open-newsletter');
    });

    document.addEventListener('shopify:section:select', (event) => {
      const overlay = event.target.querySelector?.('[data-newsletter-overlay]');
      overlay?.franziNewsletterApi?.open?.('drawer');
    });

    document.addEventListener('shopify:section:deselect', (event) => {
      const overlay = event.target.querySelector?.('[data-newsletter-overlay]');
      overlay?.franziNewsletterApi?.close?.(false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-cross-sells"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-franzi-cross-sell-recommendations]').forEach((root) => {
    const url = root.dataset.url;
    const resultsId = root.dataset.resultsId;

    if (!url || !resultsId) {
      return;
    }

    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const source = Array.from(doc.querySelectorAll('[data-franzi-recommendation-results]')).find(
          (element) => element.dataset.franziRecommendationResults === resultsId,
        );
        const target = root.querySelector('[data-franzi-recommendation-results]');

        if (!source || !target || !source.children.length) {
          return;
        }

        target.replaceChildren(...Array.from(source.children));
      })
      .catch(() => {});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('[data-franzi-product]').forEach((root) => {
    const form = root.querySelector('.franzi-product__form');
    const variantId = root.querySelector('[data-franzi-variant-id]');
    const addButton = root.querySelector('[data-franzi-add]');
    const mediaSets = root.querySelectorAll('[data-franzi-media-set]');
    const personalization = root.querySelector('[data-franzi-personalization]');
    const formError = root.querySelector('[data-franzi-form-error]');

    root.querySelectorAll('[data-franzi-variant-option]').forEach((input) => {
      input.addEventListener('change', () => {
        variantId.value = input.value;
        mediaSets.forEach((mediaSet) => {
          mediaSet.hidden = mediaSet.dataset.franziMediaSet !== input.value;
        });

        if (addButton) {
          addButton.disabled = input.dataset.available !== 'true';
        }

        if (input.dataset.variantUrl) {
          window.history.replaceState(null, '', input.dataset.variantUrl);
        }
      });
    });

    if (!form || !personalization) return;

    const propertyNamePattern = /^properties\[(.+)\]$/;

    const selectedAddonVariantId = () => {
      const addonSelect = personalization.querySelector('[data-franzi-addon-variant]');

      if (addonSelect) {
        return addonSelect.selectedOptions[0]?.dataset.franziAddonVariantId || '';
      }

      return personalization.dataset.franziAddonVariantId || '';
    };

    const selectedAddonControl = () => personalization.querySelector('[data-franzi-addon-variant]');

    const personalizationProperties = () => {
      const properties = {};
      const formData = new FormData(form);

      formData.forEach((value, name) => {
        const match = name.match(propertyNamePattern);

        if (!match || typeof value !== 'string') return;

        const trimmedValue = value.trim();

        if (trimmedValue) {
          properties[match[1]] = trimmedValue;
        }
      });

      return properties;
    };

    const addError = () => {
      if (formError) {
        formError.hidden = false;
      }

      if (addButton) {
        addButton.disabled = false;
      }
    };

    form.addEventListener('submit', async (event) => {
      const mode = personalization.dataset.franziPersonalizationMode || '';
      const addonVariantId = selectedAddonVariantId();

      if (!['bag_tag_addon', 'keyring_initials_addon'].includes(mode)) return;

      const properties = personalizationProperties();
      const hasInitials = Boolean(properties.Initials);
      const hasTagColor = Boolean(properties['Tag color']);
      const shouldAddPersonalization =
        (mode === 'keyring_initials_addon' && hasInitials) ||
        (mode === 'bag_tag_addon' && (hasTagColor || hasInitials));

      if (!shouldAddPersonalization) return;

      if (mode === 'bag_tag_addon' && (!hasTagColor || !addonVariantId)) {
        event.preventDefault();
        const addonControl = selectedAddonControl();

        if (addonControl) {
          addonControl.setCustomValidity(addonControl.dataset.franziAddonRequiredMessage || '');
          addonControl.reportValidity();
          addonControl.addEventListener('change', () => addonControl.setCustomValidity(''), { once: true });
        }

        return;
      }

      if (!addonVariantId) return;

      event.preventDefault();

      if (formError) {
        formError.hidden = true;
      }

      if (addButton) {
        addButton.disabled = true;
      }

      const quantityInput = form.querySelector('[name="quantity"]');
      const quantity = Math.max(1, Number.parseInt(quantityInput?.value || '1', 10) || 1);
      const personalizationGroup = `personalization-${variantId.value}-${Date.now()}-${Math.random()
        .toString(16)
        .slice(2)}`;
      const mainProperties = {
        ...properties,
        _franzi_personalization_group: personalizationGroup,
        _franzi_personalization_mode: mode,
      };
      const addonProperties = {
        ...properties,
        _franzi_personalization_addon: 'true',
        _franzi_personalization_group: personalizationGroup,
        _franzi_parent_variant_id: variantId.value,
        _franzi_personalization_mode: mode,
      };
      const items = [
        {
          id: Number.parseInt(variantId.value, 10),
          quantity,
          properties: mainProperties,
        },
        {
          id: Number.parseInt(addonVariantId, 10),
          quantity,
          properties: addonProperties,
        },
      ];

      try {
        const response = await fetch(root.dataset.cartAddUrl || '/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items: items }),
        });

        if (!response.ok) {
          throw new Error('Cart add failed');
        }

        window.location.href = root.dataset.cartUrl || '/cart';
      } catch (error) {
        addError();
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
